import * as React from 'react';
import * as navigate from 'app/area/shared/navigation';
import { ids } from 'app/area/administration/constants';
import { routeConstants } from 'app/routes/route-constants';
import { Link } from 'react-router-dom';
import { Link as ExternalLink, MeatballMenu } from 'ui';
import { PersonActionType } from 'app/area/administration/shared/types';
import { getInviteVeracityUserLink, isVeracityEnabled } from 'app/infrastructure/hosting';
import { Tooltip } from 'ui/common/tooltip/tooltip';
import { SearchTranslation } from 'app/area/administration/list/constants';
import { AppSetting } from 'dependencies/appsettings';
import styles from './user-toolbar.scss';

interface ToolbarProps {
  totalResultHits?: number;
  exportExcelFetching?: boolean;
  translation: SearchTranslation;
  canCreate: boolean;
  canRead: boolean;
  canRecoverMfa: boolean;
  onExportToExcel?: () => void;
}

export const UserToolbar: React.FC<ToolbarProps> = props => {
  const { totalResultHits, onExportToExcel, exportExcelFetching, canCreate, canRead, canRecoverMfa, translation } = props;

  if (!canCreate && !canRead) {
    return null;
  }

  const inviteVeracityUserLink = getInviteVeracityUserLink();
  const isExportDisabled = exportExcelFetching || totalResultHits === 0 || totalResultHits === undefined;

  const onMultiFactorAutentication = () =>
    navigate.toMultiFactorAutenticationRecovery(AppSetting.OidcServiceUrl, AppSetting.OidcClientId);

  return <>
    {!isVeracityEnabled() && canCreate && <Link id={ids.users.add_button}
      to={routeConstants.userAddFor(PersonActionType.add)} className="btn btn-primary">
      {translation.add_user}
    </Link>}
    {isVeracityEnabled() && !!inviteVeracityUserLink &&
      <Tooltip title={translation.veracity_redirect_info}>
        <ExternalLink componentId={ids.users.invite_veracity_user_button} url={inviteVeracityUserLink} className="btn btn-primary">
          {translation.invite_new_user}
        </ExternalLink>
      </Tooltip>}
    {canRead
      && <div className={styles.meatball}>
        <MeatballMenu closeAfterClick={true}>
          <li className={`${isExportDisabled ? styles.notAllowed : ''}`}>
            <button className="dropdown-item"
              id={ids.users.export_excel}
              onClick={onExportToExcel}
              disabled={isExportDisabled}>
              {translation.excel_export_item_text}
            </button>
          </li>
          {canRecoverMfa && <li>
            <button className="dropdown-item"
              id={ids.users.export_excel}
              onClick={onMultiFactorAutentication}>
              {translation.recover_mfa}
            </button>
          </li>}
        </MeatballMenu>
      </div>}
  </>;
};
